'use strict';
/**
 *  事件分析服务Module
 *  zhang.yingyu
 */
angular.module('eventAnalysisServiceModule', ['newCreatEventModule','showBigPictureModule','recentlyRankModule'])
    .factory('eventAnalysisService', ["$modal", "$q", function($modal, $q) {
    	return{
            /**
             * [newCreatEvent description] 新建或编辑事件
             * @return {[type]}          [description]
             */
    		newCreatEvent: function(item,type){
    			var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./planningCenter/eventAnalysis/service/newCreatEvent/main_tpl.html",
                    windowClass: 'newCreatEvent_window',
                    backdrop: false,
                    controller: "newCreatEventCtrl",
                    resolve: {
                       createEventI:function(){
                           return {
                               item:item
                           }
                       }
                    }
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancle");
                });
                return defer.promise;
    		},
            /**
             * [showBigPictureModal description] 显示图片
             * @return {[type]}          [description]
             */
            showBigPictureModal: function(index,picDatas){
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./planningCenter/eventAnalysis/service/showBigPicture/showBigPicture_tpl.html",
                    windowClass: 'showBigPicture_window',
                    backdrop: false,
                    controller: "showBigPictureCtrl",
                    resolve: {
                        datas:function(){
                            return {
                                index:index,
                                picDatas:picDatas
                            }
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancle");
                });
                return defer.promise;
            },
            /**
             * [recentlyRank description] 近日排名
             * @return {[type]}          [description]
             */
            recentlyRank: function(item){
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./planningCenter/eventAnalysis/service/recentlyRank/recentlyRank_tpl.html",
                    windowClass: 'recentlyRank_window',
                    backdrop: false,
                    controller: "recentlyRankCtrl",
                    resolve: {
                        datas:function(){
                            return {
                              item:item
                            };
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancle");
                });
                return defer.promise;
            }
    	};
    }]);